export const invoiceHeading = [
    { name: "ID" },
    { name: "INVOICE ID" },
    { name: "AMOUNT" },
    { name: "INVOICE DATE" },
    { name: "RECEIVED DATE" },
    { name: "STATUS" },
    { name: "INVOICE" },
    { name: "ACTION", width: 50 },
]